import { BiSolidPhoneCall } from "react-icons/bi";
import "./ticketHistory.css";
import TicketHistoryLogic from "./ticketHistoryLogic";
import { FaChevronDown, FaCopy } from "react-icons/fa";

const TicketHistory = () => {

    const {
        datasets, datasetID, agencies, agencyId, agencySearch, isAgencyDropdownOpen, showAllAgencyOptions, filteredAgencyOptions, fromDate, toDate, status,
        handleDatasetChange, handleAgencySearchChange, handleAgencyKeyDown, selectAllAgencies, selectAgencyOption, setIsAgencyDropdownOpen, setShowAllAgencyOptions, getAgencyLabel, handleFromDateChange, handleToDateChange, handleStatusChange, handleSearch,
        ticketHistory, currentPage, totalPages, startEntry, endEntry, totalRecords, pageSize, setPageSize, handleNextPage, handlePreviousPage,
        handleCopy, hasMorePages, handlePageSizeChange, isPageSizeEnabled, handleRequestClick, minDate, maxDate, filterErrors,
        setFilterErrors,
        requestType,
        setRequestType,
        responseType,
        setResponseType,
        handleRequestTypeChange,
        handleResponseTypeChange,
        appliedStatus,
        getAgencyRecordForDetailsNavigation,
        navigate
    } = TicketHistoryLogic();

    const dateFormatRecord = (dateString) => {
        if (!dateString) return "NA";

        const normalized = typeof dateString === "string"
            ? dateString.trim().replace(" ", "T")
            : dateString;

        const date = new Date(normalized);

        if (isNaN(date.getTime())) return "NA";

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };

    const shouldShowCallIcon = (req) => {
        if (!req) return false;

        if (req.filesCount > 0) {
            return false;
        }
        if (req.url) return false;

        if (!req.TriggerEvents || req.TriggerEvents.length === 0) {
            return true;
        }

        // "triggeredOnDate": "2026-06-19",
        // "triggeredAtHour": "9"

        const waitDays = Number(req.TriggerEvents[0]?.waitDays ?? 0);

        if (!req.triggeredOnDate) return false;

        const [year, month, day] = req.triggeredOnDate
            .split("-")
            .map(Number);

        const triggeredHour = Number(req.triggeredAtHour ?? 0);

        // Trigger time in ET
        const triggerET = new Date(
            `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${String(triggeredHour).padStart(2, "0")}:00:00`
        );

        const threshold = new Date(triggerET);
        threshold.setDate(threshold.getDate() + waitDays);

        const nowET = new Date(
            new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
        );

        return nowET >= threshold;
    };

    return (
        <div className="main-content">
            <div className="custom-header-ticket">
                <span className="title-req">Agency Ticket History</span>
            </div>

            <div className="mt-3">
                <div className="pagination-wrapper-ticket">

                    <span className="showing-text">
                        Showing {startEntry} to {endEntry} of {totalRecords} entries
                    </span>

                    {/* Limit Dropdown */}
                    <span>Show</span>

                    <select
                        className="form-select"
                        value={pageSize}
                        disabled={!isPageSizeEnabled}
                        onChange={(e) => handlePageSizeChange(e.target.value)}
                    >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>

                    {/* Pagination */}
                    <ul className="pagination-ticket">

                        {/* Previous */}
                        <li>
                            <button
                                className="page-btn-ticket"
                                disabled={currentPage === 1}
                                onClick={handlePreviousPage}
                            >
                                &lt;
                            </button>
                        </li>

                        {/* Page Number */}
                        <li>
                            <button className="page-btn-ticket page-btn-active">
                                {currentPage}
                            </button>
                        </li>

                        {/* Next */}
                        <li>
                            <button
                                className="page-btn-ticket"
                                disabled={currentPage === totalPages || ticketHistory.length === 0}
                                onClick={handleNextPage}
                            >
                                &gt;
                            </button>
                        </li>

                    </ul>

                </div>

                <div className="table-content-ticket">

                    <form className="filter-row-ticket" onSubmit={handleSearch}>
                        {/* Dataset */}
                        <div className="filter-item-ticket">
                            <label>Dataset</label>
                            <select
                                className={`form-select ${filterErrors.datasetID ? "is-invalid" : ""}`}
                                value={datasetID}
                                onChange={(e) => {
                                    handleDatasetChange(e);
                                    setFilterErrors(p => ({ ...p, datasetID: "" }));
                                }}
                            >
                                <option value="">Select Dataset</option>
                                {datasets.map((ds) => (
                                    <option key={ds.id} value={ds.datasetID}>
                                        {ds.datasetName}
                                    </option>
                                ))}
                            </select>
                            {filterErrors.datasetID && <div className="filter-error-text">{filterErrors.datasetID}</div>}
                        </div>

                        {/* Agency */}
                        <div className="filter-item-ticket">
                            <label>Agency</label>
                            <div
                                className={`ticket-search-select ${!datasetID ? "disabled" : ""}`}
                                onBlur={(event) => {
                                    if (!event.currentTarget.contains(event.relatedTarget)) {
                                        setIsAgencyDropdownOpen(false);
                                    }
                                }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    value={agencySearch}
                                    onChange={handleAgencySearchChange}
                                    onFocus={(event) => {
                                        setIsAgencyDropdownOpen(true);
                                        setShowAllAgencyOptions(false);
                                        event.target.select();
                                    }}
                                    onKeyDown={handleAgencyKeyDown}
                                    placeholder={datasetID ? "All Agencies" : "Select Dataset First"}
                                    autoComplete="off"
                                    disabled={!datasetID}
                                />

                                <button
                                    className="ticket-search-select-toggle"
                                    type="button"
                                    onClick={() => {
                                        if (!showAllAgencyOptions) {
                                            setShowAllAgencyOptions(true);
                                            setIsAgencyDropdownOpen(true);
                                            return;
                                        }
                                        setShowAllAgencyOptions(false);
                                        setIsAgencyDropdownOpen(false);
                                    }}
                                    aria-label="Toggle agency options"
                                    disabled={!datasetID}
                                >
                                    <FaChevronDown />
                                </button>

                                {isAgencyDropdownOpen && (
                                    <div className="ticket-search-select-menu">
                                        <button
                                            type="button"
                                            className={`ticket-search-select-option ${!agencyId ? "selected" : ""}`}
                                            onMouseDown={(event) => event.preventDefault()}
                                            onClick={selectAllAgencies}
                                        >
                                            All Agencies
                                        </button>

                                        {filteredAgencyOptions.length > 0 ? (
                                            filteredAgencyOptions.map((agency, index) => (
                                                <button
                                                    key={`${agency._id || agency.id || agency.agencyID || getAgencyLabel(agency)}-${index}`}
                                                    type="button"
                                                    className={`ticket-search-select-option ${agencyId === agency.agencyID ? "selected" : ""}`}
                                                    onMouseDown={(event) => event.preventDefault()}
                                                    onClick={() => selectAgencyOption(agency)}
                                                >
                                                    {getAgencyLabel(agency)}
                                                </button>
                                            ))
                                        ) : (
                                            <div className="ticket-search-select-empty">
                                                No agencies found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* From Date */}
                        <div className="filter-item-ticket">
                            <label>From</label>
                            <input
                                type="date"
                                className={`form-control ${filterErrors.fromDate ? "is-invalid" : ""}`}
                                value={fromDate}
                                min={minDate}
                                max={maxDate}
                                onChange={(e) => {
                                    handleFromDateChange(e);
                                    setFilterErrors(p => ({ ...p, fromDate: "", toDate: "" }));
                                }}
                            />
                            {filterErrors.fromDate && (
                                <div className="filter-error-text">{filterErrors.fromDate}</div>
                            )}
                        </div>

                        {/* To Date */}
                        <div className="filter-item-ticket">
                            <label>To</label>
                            <input
                                type="date"
                                className={`form-control ${filterErrors.toDate ? "is-invalid" : ""}`}
                                value={toDate}
                                min={minDate}
                                max={maxDate}
                                onChange={(e) => {
                                    handleToDateChange(e);
                                    setFilterErrors(p => ({ ...p, toDate: "" }));
                                }}
                            />
                            {filterErrors.toDate && (
                                <div className="filter-error-text">{filterErrors.toDate}</div>
                            )}
                        </div>

                        {/* Request Method */}
                        <div className="filter-item-ticket">
                            <label>Request Type</label>
                            <select
                                className={`form-select ${filterErrors.requestType ? "is-invalid" : ""}`}
                                value={requestType}
                                onChange={(e) => {
                                    handleRequestTypeChange(e);
                                    setFilterErrors(p => ({ ...p, requestType: "" }));
                                }}
                            >
                                <option value="">Select</option>
                                <option value="email">Email</option>
                                <option value="fax">Fax</option>
                            </select>
                            {filterErrors.requestType && <div className="filter-error-text">{filterErrors.requestType}</div>}
                        </div>

                        {/* Response Method */}
                        <div className="filter-item-ticket">
                            <label>Response Type</label>
                            <select
                                className={`form-select ${filterErrors.responseType ? "is-invalid" : ""}`}
                                value={responseType}
                                onChange={(e) => {
                                    handleResponseTypeChange(e);
                                    setFilterErrors(p => ({ ...p, responseType: "" }));
                                }}
                            >
                                <option value="">Select</option>
                                <option value="email">Email</option>
                                <option value="fax">Fax</option>
                            </select>
                            {filterErrors.responseType && <div className="filter-error-text">{filterErrors.responseType}</div>}
                        </div>

                        {/* Status */}
                        <div className="filter-item-ticket">
                            <label>Status</label>
                            <select
                                className={`form-select ${filterErrors.status ? "is-invalid" : ""}`}
                                value={status}
                                onChange={(e) => { handleStatusChange(e); setFilterErrors(p => ({ ...p, status: "" })); }}
                            >
                                <option value="">Select Status</option>
                                <option value="all">All</option>
                                <option value="call for status">Call for Status</option>
                                <option value="Escalated">Escalated</option>
                                <option value="Sent">Sent</option>
                                <option value="Closed-Data Received">Closed-Data Received</option>
                                <option value="Closed-No Data">Closed-No Data</option>
                                <option value="Payment Pending">Payment Pending</option>
                                <option value="Payment Closed">Payment Closed</option>
                            </select>
                            {filterErrors.status && <div className="filter-error-text">{filterErrors.status}</div>}
                        </div>

                        {/* Search Button */}
                        <div className="search-box-ticket">
                            <button type="submit" className="w-100">
                                Search
                            </button>
                        </div>

                    </form>


                    <div class="table-shadow-ticket">

                        <div class="table-wrapper-ticket">
                            <table className="ticket-list-table" >
                                <thead className="thead-dark">
                                    <tr>
                                        <th>Request Id</th>
                                        <th>Agency</th>
                                        <th>Requested Date</th>
                                        <th>Request Type</th>
                                        <th>Response Type</th>
                                        <th>Status</th>
                                        <th>Date Range Requested</th>
                                        {(appliedStatus === "Closed-Data Received" || appliedStatus === "all") && (
                                            <>
                                                <th>File Received Date</th>
                                                <th>Files & Cases</th>
                                            </>
                                        )}
                                        {/* {(appliedStatus === "Closed-Data Received" || appliedStatus === "all") && <th>Files/PDF</th>} */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {ticketHistory.length > 0 ? (
                                        ticketHistory.map((req, index) => (
                                            <tr key={index}>
                                                <td className="selectable-text ">
                                                    {shouldShowCallIcon(req) && (
                                                        <BiSolidPhoneCall className="call-icon"
                                                        // onClick={() => openModal(req.requestID)}
                                                        />
                                                    )} &ensp;
                                                    <span
                                                        style={{ color: "#09c", cursor: "pointer", textDecoration: "underline" }}
                                                        onClick={() => handleRequestClick(req)}

                                                    >
                                                        {req.requestID}
                                                    </span>
                                                    <FaCopy style={{ marginLeft: "8px", cursor: "pointer", color: "#09c" }}
                                                        title="Copy"
                                                        onClick={() => handleCopy(req.requestID)}
                                                    />
                                                </td>
                                                <td className="agency-col">
                                                    <div className="agency-content">


                                                        <span onClick={async () => {
                                                            const agencyIDForPayload = req.agencyID || req.agencyId || agencyId || "";
                                                            const selectedAgency = agencies.find((agency) => String(agency.agencyID || agency.agencyId) === String(agencyIDForPayload));
                                                            const fullAgency = await getAgencyRecordForDetailsNavigation(selectedAgency);
                                                            const agencySource = fullAgency || selectedAgency || {};
                                                            const datasetIDForPayload = req.datasetID || "";
                                                            const selectedDataset = datasets.find((ds) => ds.datasetID === datasetIDForPayload);
                                                            const datasetNameForPayload = req.datasetName || selectedDataset?.datasetName || selectedDataset?.dataSetName || "";
                                                            const payload = {
                                                                ...req,
                                                                ...agencySource,
                                                                datasetID: datasetIDForPayload,
                                                                datasetName: datasetNameForPayload,
                                                                agencyID: agencyIDForPayload,

                                                                agencyName:
                                                                    agencySource.agencyName ||
                                                                    agencySource.agencyDisplayName ||
                                                                    req.agencyName ||
                                                                    "",

                                                                agencyPhoneNumber:
                                                                    agencySource.agencyPhoneNumber ||
                                                                    agencySource.agencyPhoneNumbers?.find(p => p.isPrimary)?.number ||
                                                                    agencySource.agencyPhoneNumbers?.[0]?.number ||
                                                                    req.agencyPhoneNumber ||
                                                                    "",

                                                                requestType: agencySource.requestMethod?.requestType || "",
                                                                responseType: agencySource.responseMethod?.responseType || "",

                                                            };

                                                            localStorage.setItem("agencyDetailsPayload", JSON.stringify(payload));

                                                            // Open in new tab with URL parameters
                                                            const url = `/AgencyDetailPage`;
                                                            window.open(url, "_blank");
                                                        }} style={{ color: "#09c", cursor: "pointer" }} className="agency-text">

                                                            {req.agencyID && req.agencyName
                                                                ? `${req.agencyID} - ${req.agencyName}`
                                                                : "NA"}
                                                        </span>

                                                    </div>

                                                </td>
                                                <td>
                                                    {req.triggeredOnDate
                                                        ? `${dateFormatRecord(req.triggeredOnDate)}
                                                        `
                                                        : "NA"}
                                                </td>
                                                <td>{req.requestMethod?.requestType || "-"}</td>
                                                <td>{req.responseMethod?.responseType || "-"}</td>
                                                <td>{req.outgoingRequest_Status?.trim() || "sent"}</td>
                                                <td>
                                                    {(() => {
                                                        const baseDate = new Date(req.triggeredOnDate);
                                                        if (isNaN(baseDate)) return "-";
                                                        const offsetBegin = Number(req?.reqRange?.offsetBegins ?? 0);
                                                        const offsetEnd = Number(
                                                            req?.reqRange?.offsetEnds === "" ||
                                                                req?.reqRange?.offsetEnds === undefined
                                                                ? 0
                                                                : req.reqRange.offsetEnds
                                                        );
                                                        const from = new Date(baseDate);
                                                        from.setDate(from.getDate() + offsetBegin);
                                                        const to = new Date(baseDate);
                                                        to.setDate(to.getDate() + offsetEnd);
                                                        return `${dateFormatRecord(from)} - ${dateFormatRecord(to)}`;
                                                    })()}
                                                </td>
                                                {(appliedStatus === "Closed-Data Received" || appliedStatus === "all") && (
                                                    <>
                                                        <td>
                                                            {req.fileReceivedTime
                                                                ? dateFormatRecord(req.fileReceivedTime)
                                                                : "-"}
                                                        </td>

                                                        <td>
                                                            {/* {`${req.filesCount || 0} File with ${req.casesCount || 0} Cases`} */}
                                                            {
                                                                req.filesCount === 0
                                                                    ? 'No Files'
                                                                    : (req.casesCount || 0) === 0
                                                                        ? `${req.filesCount} ${req.filesCount === 1 ? 'File' : 'Files'} & Cases Yet to Start`
                                                                        : `${req.filesCount} ${req.filesCount === 1 ? 'File' : 'Files'} with ${req.casesCount} ${req.casesCount === 1 ? 'Case' : 'Cases'}`
                                                            }
                                                        </td>
                                                    </>
                                                )}
                                                {/* {(appliedStatus === "Closed-Data Received" || appliedStatus === "all") && (
                                                    <td>
                                                        {req.files && req.files.length > 0 ? (
                                                            req.files.map((file, fileIndex) => (
                                                                <a
                                                                    key={fileIndex}
                                                                    href={file.fileUrl}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ display: "block", color: "#09c" }}>
                                                                    <FaExternalLinkSquareAlt style={{ marginRight: "4px" }} />
                                                                    {file.fileName || `File ${fileIndex + 1}`}
                                                                </a>
                                                            ))
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                )} */}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr className="no-record-row">
                                            <td colSpan={(appliedStatus === "Closed-Data Received" || appliedStatus === "all") ? 9 : 7} className="text-center">
                                                No Records Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>


                            </table>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default TicketHistory
